import React from "react"
import styled from "@emotion/styled"
import hash from "@emotion/hash"

import { useConsole } from "contexts/Console"
import { fullGrid } from "css/grid"
import getMediaQuery from "css/breakpoints"
import { spacing } from "css/spacing"
import { Heading as HeadingClass, Chapo as ChapoClass, Paragraph as ParagraphClass } from "css/classnames"

import Heading from "components/text/Heading"
import Chapo from "components/text/Chapo"
import Paragraph from "components/text/Paragraph"

import { StateProvider } from "./context"

import EditoFilters from "./EditoFilters"

const hAlign = {
  start: `ha${hash("hori-start")}`,
  center: `ha${hash("hori-center")}`,
}
const txtJustif = {
  start: `ha${hash("txt-justify-start")}`,
  center: `ha${hash("txt-justify-center")}`,
}

const Section = styled.section`
  ${fullGrid}
  ${spacing}
  
  width: 100%;
  overflow: hidden;
  padding: max(60px, 10vh) 0;

  background-color: rgb(var(--light-black));

  ${getMediaQuery("m")} {
    padding: max(80px, 10vh) 0;
  }
`

const TextBlock = styled.div`
  &.${txtJustif.start} {
    text-align: start;
  }
  &.${txtJustif.center} {
    text-align: center;
  }
  &.${hAlign.center} {
    grid-column: col 1 / span 6;
    ${getMediaQuery("m")} {
      grid-column: col 4 / span 6;
    }
  }

  &.${hAlign.start} {
    grid-column: col 1 / span 6;
  }

  .${HeadingClass} {
    &:not(:last-child) {
      margin-block-end: 20px;
    }
  }
  .${ChapoClass} {
    &:not(:last-child) {
      margin-block-end: 20px;
    }
  }

  .${HeadingClass}:last-child, .${ChapoClass}:last-child, .${ParagraphClass}:last-child {
    margin-block-end: 60px;
  }

  ${getMediaQuery("m")} {
    .${HeadingClass}:last-child, .${ChapoClass}:last-child, .${ParagraphClass}:last-child {
      margin-block-end: 80px;
    }
  }
`

export default function EditoExplore({ heading, tabs, paragraph, chapo, className, horizontal_align, justify_text }) {
  const console = useConsole()

  const txtCN = hAlign[horizontal_align || "center"] + " " + txtJustif[justify_text || "center"]

  return (
    <StateProvider>
      <Section className={`${className} dark-theme`}>
        <TextBlock className={txtCN}>
          <Heading className={HeadingClass} {...heading} />
          {chapo ? <Chapo className={ChapoClass} text={chapo} /> : null}
          {paragraph ? <Paragraph className={ParagraphClass} text={paragraph} /> : null}
        </TextBlock>
        <EditoFilters tabs={tabs} />
      </Section>
    </StateProvider>
  )
}
